export const promoBlackList = ['/sleep-fitness-challenge', '/rewards', '/miami', '/miami/']

export const mattressBlacklist = ['tim']
